import { entityReducer as tokensPersistence } from "../../../modules/storage";
import tokens from "./tokens";
export default {
  tokens,
  tokensPersistence
};